export default "__VITE_ASSET__DZFRXL6y__"